import {
  get,
  internalDestroy,
  internalGet,
  internalPatch,
  internalPost,
} from './';

export const getPartnerships = () => get(`/partnerships`);

export const getPartnership = ({ id }) => internalGet(`/partnerships/${id}`);

export const createPartnership = (payload) =>
  internalPost(`/partnerships`, payload);

export const updatePartnership = (id, payload) =>
  internalPatch(`/partnerships/${id}`, payload);

export const deletePartnership = (id) => internalDestroy(`/partnerships/${id}`);
